import React, { useEffect, useRef, useState } from "react";
import {
  ChatWindowComponentPaper,
  MessageContainer,
  ChatWindowAvatar,
} from "../styles/ChatWindowComponent.styled";
import Message from "./Message";
import { MessageWrapper } from "../styles/ChatWindowComponent.styled";
import ShineThinking from "../../../elements/ShineThinking";
import { toJS } from "mobx";
import {useMediaQueries} from "../../../utils/mediaQueries";
import AnnAvatarDark from '../../../images/icon_dark_bg.png';

const ChatWindowComponent = ({
  messages,
  bottomRef,
  className,
  displayButtons = true,
  width,
  height,
  chatWindowHeight,
  agentIsTyping,
  boxShadow,
  showImage,
  selectedAgent,
  dataTestId,
}) => {
  let filteredMessages = [];
  let lastReceivedIndex = -1;
  const chatWindowRef = useRef(null);
  const [, setAgentImg] = useState(AnnAvatarDark)
  const {isMobile, isDesktop, isIpadAirLandscape,isIpadAirPortrait,  isIpadProLandscape,  isIpadProPortrait} = useMediaQueries();

  useEffect(() => {
    const agent = toJS(selectedAgent)
    if (agent?.photo_url) {
      setAgentImg(agent.photo_url)
    }
  }, [selectedAgent])

  useEffect(() => {
    const handleLinkClick = (event) => {
      const link = event.target.closest("a");
      if (link && link.tagName === "A" && link.target !== "_blank") {
        event.preventDefault();
        window.open(link.href, "_blank");
        event.stopPropagation();
      }
    };

    const chatWindow = chatWindowRef.current;
    if (chatWindow) {
      chatWindow.addEventListener("click", handleLinkClick);
    }

    return () => {
      if (chatWindow) {
        chatWindow.removeEventListener("click", handleLinkClick);
      }
    };
  }, []);

  messages.forEach((message, index) => {
    if (message.type !== "received") {
      filteredMessages.push(message);
    } else {
      // Check if this received message is consecutive with the previous one
      if (index === 0 || messages[index - 1].type !== "received") {
        lastReceivedIndex = filteredMessages.length;
        filteredMessages.push(message);
      } else {
        filteredMessages[lastReceivedIndex] = message;
      }
    }
  });

  return (
    <ChatWindowComponentPaper
      ref={chatWindowRef}
      elevation={3}
      className={className}
      $height={height}
      chatWindowHeight={chatWindowHeight}
      boxShadow={boxShadow}
      isMobile={isMobile}
      isDesktop={isDesktop}
      isIpadAirLandscape={isIpadAirLandscape}
      isIpadAirPortrait={isIpadAirPortrait}
      isIpadProLandscape={isIpadProLandscape}
      isIpadProPortrait={isIpadProPortrait}
      data-testid={dataTestId}
    >
      {showImage && !messages.length && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <img alt="Concierge Agent" />
        </div>
      )}

      {filteredMessages.map((item, index) => (
        <Message
          key={index}
          messageItem={item}
          displayButtons={displayButtons}
          width={width}
          selectedAgent={selectedAgent}
        />
      ))}

      {agentIsTyping && messages.type !== "sent" && (
        <MessageContainer width={width}>
          <ChatWindowAvatar src={AnnAvatarDark} alt="Agent Avatar" />
          <MessageWrapper $flex>
            <ShineThinking />
          </MessageWrapper>
        </MessageContainer>
      )}

      <div ref={bottomRef} />
    </ChatWindowComponentPaper>
  );
};

export default ChatWindowComponent;
